export enum UserConfigKeyEnum {
    reviewsFilter = 'reviewsFilter',
}
